module.exports = __webpack_public_path__ + "media/images/icons/outlined/dingding-1b1b11134c8b682cae9a128b7e34c352.svg";